// constants
import { LOG_TABLES } from "constants/index";

// libs
import { makeApiCall } from "@swiggy-private/js-utils";

// defs
import type { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge/dist/interfaces";

// utiles
import { getSwiggyHeaders, getUserHeaders } from "./headers";
import { sendCustomNREvViaBlaze } from "./newrelic";

export interface IOptions extends RequestInit {
    searchParams?: Record<string, string>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const customApiCall = async (apiHost: string, apiEndpoint: string, opts?: IOptions): Promise<any> => {
    const swHeaders = (await getSwiggyHeaders()) as GetSwiggyHeadersResponsePayload;
    const userHeaders = getUserHeaders();
    const options: IOptions = {
        ...opts,
        headers: {
            ...(opts?.headers || {}),
            ...(userHeaders || {}),
        },
        searchParams: {
            lat: swHeaders?.lat || "",
            lng: swHeaders?.lng || "",
            ...opts?.searchParams,
        },
    };

    return makeApiCall(
        {
            apiHost: apiHost,
            endpoint: apiEndpoint,
            options,
            searchParams: options.searchParams,
        },
        swHeaders,
        sendCustomNREvViaBlaze,
        LOG_TABLES,
    );
};
